/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Decks_Round_LabelInputs */



/**
* | output |
* | --- |
* | "Round {n}" |
*
* @param {Decks_Round_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_round_label = /** @type {((inputs: Decks_Round_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Round_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ronde ${i?.n}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Ronda ${i?.n}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Rodada ${i?.n}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Round ${i?.n}`)
	return /** @type {LocalizedString} */ (`Round ${i?.n}`)
});